import React, { useState } from 'react';
import { MdModeEdit, MdInfo } from 'react-icons/md';
import {
  Container, Distance, Header, Label, Medal, HeaderContainer,
  InfoContainer,
  EditContainer,
  EditText,
  TitleContainer,
  IconButton,
} from './styles';

import { ChallengeStatesTypes } from '../../pages/ChallengePage';
import ChallengeInfoModal from '../ChallengeInfoModal';
import { ChallengeDetailType } from '../../types/Challenger';

interface Props {
  edit: () => void
  status: ChallengeStatesTypes,
  challengeDetail: ChallengeDetailType
}

export default function ChallengeHeader(
  {
    edit, status, challengeDetail,
  }: Props,
) {
  const [infoModal, setInfoModal] = useState(false);
  return (
    <>
      <ChallengeInfoModal isVisible={infoModal} setVisible={setInfoModal} />
      <Container>

        <Medal src={challengeDetail.medal} />
        <HeaderContainer>
          <TitleContainer>
            <Header>{challengeDetail.title}</Header>
            <IconButton onClick={() => setInfoModal(true)}>
              <MdInfo color="white" size={22} />
            </IconButton>
          </TitleContainer>
          <InfoContainer>
            <div>
              <Label>Distância</Label>
              <Distance>{`${challengeDetail.distance}km`}</Distance>
            </div>
            {status === 'IN_PROGRESS' && challengeDetail.type !== 'DATE' && (
              <EditContainer onClick={edit}>
                <MdModeEdit color="white" />
                <EditText>Editar meta de tempo</EditText>
              </EditContainer>
            )}
          </InfoContainer>
        </HeaderContainer>
      </Container>
    </>
  );
}
